import { Component, computed, inject, output, signal } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { ChatFacade } from 'src/shared/stores/chat/chat-facade.store';
import { PolicyStore } from 'src/shared/stores/policy/policy.store';
import { UserStore } from 'src/shared/stores/user.store';
import { entities } from 'src/shared/services/client/client';
import { GrowthbookService } from 'src/shared/services/growthbook/growthbook.service';
import { MixpanelService } from 'src/shared/services/mix-panel.service/mix-panel.service';
import { RemoteConfigService } from 'src/shared/services/remote-config/remote-config.service';

@Component({
  selector: 'app-chat-pet-selection',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './chat-pet-selection.component.html',
  styleUrl: './chat-pet-selection.component.scss',
})
export class ChatPetSelectionComponent {
  userStore = inject(UserStore);
  chatStore = inject(ChatFacade);
  policyStore = inject(PolicyStore, { optional: true });
  mixpanelService = inject(MixpanelService);
  growthBook = inject(GrowthbookService);
  remoteConfig = inject(RemoteConfigService);

  private isInsurer = computed(() => !!this.policyStore?.tenant()?.insurer);

  pets = computed(() => {
    const allPets = this.userStore.pets();
    if (this.isInsurer()) {
      return allPets.filter((pet) => pet.policy_active);
    }
    return allPets;
  });

  selectedPet = signal<entities.PetResponse | null>(null);
  hasCompletedChats = computed(() => this.chatStore.data.chats().length > 0);

  petConfirmed = output<entities.PetResponse>();
  dismissed = output<void>();
  back = output<void>();

  selectPet(pet: entities.PetResponse) {
    this.selectedPet.set(pet);
  }

  confirmSelection() {
    const pet = this.selectedPet();
    if (pet) {
      this.mixpanelService.track('llm_onboarding.pet_selection', {
        pet_doc_id: pet.doc_id,
        experiment_article_feed: this.growthBook.experimentOn('article_feed'),
        experiment_llm_pre_chat_journey: this.growthBook.featureValue<boolean>('llm_pre_chat_triage_enabled', false),
        experiment_llm_pre_chat_journey_v2: this.growthBook.experimentOn('llm-triage-general'),
        config_llm_chat_enabled: this.remoteConfig.readBoolean('llm_chat_enabled') ?? false,
        'experiment_llm-triage-general': this.growthBook.experimentOn('llm-triage-general'),
      });
      this.petConfirmed.emit(pet);
    }
  }

  onBackClick() {
    if (this.hasCompletedChats()) {
      this.back.emit();
    } else {
      this.dismissed.emit();
    }
  }

  onCloseClick() {
    this.dismissed.emit();
  }
}
